
import axiosClient from "../axiosClient";
import {    
  CREATE_ACCOUNTGROUP_URL,
    CREATE_FINANCIAL_YEAR_URL,
    CREATE_LEDGER_URL,
    CREATE_OPENING_BALANCE,
    CREATE_VOUCHERTYPE_URL,
    DELETE_ACCOUNTGROUP_URL,
    GET_OPENING_BALANCE_BY_ID,
    GET_OPENING_BALANCE_GETALL,
    GETALL_ACCOUNTGROUP_URL,
    GETALL_FINANCIALYEAR_URL,
    GETALL_LEDGER_URL,
    GETALL_VOUCHERTYPE_URL,
    GETBYID_ACCOUNTGROUP_URL,
    GETBYID_FINANCIAL_YEAR_URL,
    GETBYID_LEDGER_URL,
    GETBYID_VOUCHERTYPE_URL,
    UPDATE_ACCOUNTGROUP_URL,
    UPDATE_FINANCIAL_YEAR_URL,
    UPDATE_LEDGER_URL,
    UPDATE_OPENING_BALANCE,
    UPDATE_VOUCHERTYPE_URL,
} from "../endpoints";

//account group
export const accountmasterservice = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_ACCOUNTGROUP_URL);
      return response.data;
    } catch (error) {
      throw new Error("Fetch Failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_ACCOUNTGROUP_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {

    try {
      const response = await axiosClient.post(UPDATE_ACCOUNTGROUP_URL, payload);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.post(DELETE_ACCOUNTGROUP_URL, {
        id: id,// Use 'data' for the request payload
      });
      return response.data; 
     } catch (error) {
        throw new Error("Deletion failed");
      }
    },
  
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_ACCOUNTGROUP_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
 //ledger
 export const ledgermasterservice = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_LEDGER_URL);
      return response.data;
    } catch (error) {
      throw new Error("Fetch Failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_LEDGER_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {

    try {
      const response = await axiosClient.post(UPDATE_LEDGER_URL, payload);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.post(DELETE_ACCOUNTGROUP_URL, {
        id: id,// Use 'data' for the request payload
      });
      return response.data; 
     } catch (error) {
        throw new Error("Deletion failed");
      }
    },
  
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_LEDGER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};

 //fin year
export const financialyearservice = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_FINANCIALYEAR_URL);
      return response.data;
    } catch (error) {
      throw new Error("Fetch Failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(CREATE_FINANCIAL_YEAR_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_FINANCIAL_YEAR_URL, 
        payload
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_FINANCIAL_YEAR_URL, {
        params: { id }, // Replace with the correct endpoint for fetching financial year by ID
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};

// opening balance
export const openingbalanceservice = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GET_OPENING_BALANCE_GETALL);
      return response.data;
    } catch (error) {
      throw new Error("Fetch Failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_OPENING_BALANCE,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(UPDATE_OPENING_BALANCE, payload);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GET_OPENING_BALANCE_BY_ID, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};

//voucher type 
// VoucherType Service
export const vouchertypeservice = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_VOUCHERTYPE_URL);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw new Error("Failed to fetch voucher types");
    }
  },

  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(CREATE_VOUCHERTYPE_URL, createData);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw new Error("Failed to create voucher type");
    }
  },

  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(UPDATE_VOUCHERTYPE_URL, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating voucher type:", error);
      throw new Error("Failed to update voucher type");
    }
  },

  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_VOUCHERTYPE_URL, {
        params: { id },
      });
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw new Error("Failed to load voucher type by ID");
    }
  },
};

//voucher 
export const voucherservice = {
  getall: async (branchcode: string) => {
    try {
      const response = await axiosClient.get('/Voucher/GetAllVoucher', {
        params: { branchcode },
      });
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch vouchers");
    }
  },

  getbyId: async (voucherId: string) => {
    try {
      const response = await axiosClient.get('/Voucher/GetVoucherItemByVoucherId', {
        params: { voucherId },
      });
      return response.data;
    } catch (error) {
      throw new Error("Failed to load voucher by ID");
    }
  },

  create: async (createData: any) => {
    try {
      const response = await axiosClient.post('/Voucher/CreateVoucherEntry', createData);
      return response.data;
    } catch (error) {
      throw new Error("Failed to create voucher");
    }
  },
};